import React from 'react';
import { Modal, Box, Typography, Button, Stack } from '@mui/material';

const ModalComponent = ({
    modalOpen = false,
    handleCloseModal,
    onClose,
    title = '',
    message = '',
    buttons = [], // Array of { text: string, onClick: function, color?: string }
    disableBackdropClick = false
}) => (
    <Modal
        open={modalOpen}
        sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        }}
        onClose={(event, reason) => {
            if (disableBackdropClick && reason && reason === "backdropClick") {
                return;
            }
            if (handleCloseModal) handleCloseModal();
            if (onClose) onClose();
        }}
    >
        <Box
            sx={{
                bgcolor: 'background.paper',
                p: 3,
                outline: 'none',
                width: '92vw',
                maxWidth: '480px',
                maxHeight: '90vh',
                overflowY: 'auto',
                boxShadow: '0 20px 56px rgba(29, 29, 27, 0.18)',
                borderRadius: 4,
                border: '1px solid rgba(223, 191, 193, 0.45)',
            }}
        >
            <Typography id="modal-title" variant="h3" component="h2" sx={{ color: 'primary.main' }}>
                {title}
            </Typography>
            <Typography id="modal-description" sx={{ mt: 2, color: 'text.secondary', whiteSpace: 'pre-line' }}>
                {message.split('\n').map((line, index) => (
                    <React.Fragment key={index}>
                        {line}
                        <br />
                    </React.Fragment>
                ))}
            </Typography>
            {Array.isArray(buttons) && buttons.length > 0 && (
                <Stack spacing={1.5} sx={{ mt: 3 }}>
                    {buttons.map((btn, index) => (
                        <Button
                            key={index}
                            variant={btn.variant || 'contained'}
                            color={btn.color || 'primary'}
                            fullWidth
                            onClick={btn.onClick}
                            sx={{
                                borderRadius: 3,
                                minHeight: 48,
                                fontWeight: 800,
                                bgcolor: btn.color ? undefined : 'primary.main',
                            }}
                        >
                            {btn.text}
                        </Button>
                    ))}
                </Stack>
            )}

        </Box>
    </Modal>
);

export default ModalComponent;
